import dayjs from "dayjs";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Filters from "../../common/reports/Filters";
import {
  BETWEEN,
  DATE,
  GTE,
  LIKE,
  LTE,
} from "../../common/reports/reportConstants";
import { createFilterParam } from "../../common/reports/reportUtils";
import Button from "../../framework/Button";
import DatePicker from "../../framework/date/DatePicker";
import GlobalContext from "../../framework/GlobalContext";
import TextInput from "../../framework/TextInput";
import { executeScroll, isEmpty } from "../../utils/utils";
import Shortcut from "../../framework/Shortcut";
import NumberInput from "../../framework/NumberInput";
import SelectInput from "../../framework/SelectInput";
import { fetchBranches } from "../../services/branch-service";
const MedicineWiseStockAuditReportFilter = ({
  onFilterShow,
  applyFilterOnMount = true,
  refreshData = false,
  //applyFilters = () => {},
  reportRef,
}) => {
  const [startDate, setStartDate] = useState(dayjs().subtract(7, "day"));
  const [endDate, setEndDate] = useState(dayjs());
  const [auditStartDate, setAuditStartDate] = useState(
    dayjs().subtract(7, "day")
  );
  const [auditEndDate, setAuditEndDate] = useState(dayjs());
  const [branch, setBranch] = useState("");
  const [medicine, setMedicine] = useState("");
  const [batch, setBatch] = useState("");
  const [auditId, setAuditId] = useState("");
  const [auditedBy, setAuditedBy] = useState("");
  const [limit, setLimit] = useState(100);

  const filterStartDateRef = useRef();
  const filterEndDateRef = useRef();
  const filterAuditStartDateRef = useRef();
  const filterAuditEndDateRef = useRef();
  const filterBranchCodeRef = useRef();
  const filterBranchRef = useRef();
  const filterMedicineRef = useRef();
  const filterBatchRef = useRef();
  const filterAuditRequestIdRef = useRef();
  const filterAuditedByRef = useRef();
  const filterLimitRef = useRef();
  const applyFilterRef = useRef();
  const [orderBy] = useState([
    { fieldName: "businessDate", orderType: "desc" },
  ]);
  const { setCurrentComponent } = useContext(GlobalContext);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branchSuggestions, setBranchSuggestions] = useState([]);
  const handleBranchInputChange = (event) => {
    const value = event.target.value || "";
    if (value.length > 2) {
      setBranchSuggestions([]);
      fetchBranches({ search: value }).then((resp) => {
        let updatedResp = resp.result.rows.map((branch) => ({
          id: branch._id,
          label: branch.code,
        }));
        setBranchSuggestions(updatedResp);
      });
    }
  };
  const applyFilterHandler = useCallback(
    (isFilterChanged = false) => {
      let filters = [];
      let result = {};
      const _startDate = startDate?.format("DD/MM/YYYY");
      const _endDate = endDate?.format("DD/MM/YYYY");
      if (_startDate && !_endDate) {
        filters.push(
          createFilterParam(
            "stockAuditRequestCreatedTime",
            _startDate,
            DATE,
            GTE
          )
        );
      }
      if (!_startDate && _endDate) {
        filters.push(
          createFilterParam("stockAuditRequestCreatedTime", _endDate, DATE, LTE)
        );
      }
      if (_startDate && _endDate) {
        filters.push(
          createFilterParam(
            "stockAuditRequestCreatedTime",
            { start: _startDate, end: _endDate },
            DATE,
            BETWEEN
          )
        );
      }

      const _auditStartDate = auditStartDate?.format("DD/MM/YYYY");
      const _auditEndDate = auditEndDate?.format("DD/MM/YYYY");
      if (_auditStartDate && !_auditEndDate) {
        filters.push(
          createFilterParam("businessDate", _auditStartDate, DATE, GTE)
        );
      }
      if (!_auditStartDate && _auditEndDate) {
        filters.push(
          createFilterParam("businessDate", _auditEndDate, DATE, LTE)
        );
      }
      if (_auditStartDate && _auditEndDate) {
        filters.push(
          createFilterParam(
            "businessDate",
            { start: _auditStartDate, end: _auditEndDate },
            DATE,
            BETWEEN
          )
        );
      }
      if (!isEmpty(branch)) {
        filters.push(createFilterParam("branchName", branch, "string", LIKE));
      }
      if (!isEmpty(medicine)) {
        filters.push(
          createFilterParam("medicineName", medicine, "string", LIKE)
        );
      }
      if (!isEmpty(batch)) {
        filters.push(createFilterParam("batchNumber", batch, "string", LIKE));
      }
      if (!isEmpty(auditId)) {
        filters.push(
          createFilterParam("stockAuditId", auditId, "string", LIKE)
        );
      }
      if (!isEmpty(auditedBy)) {
        filters.push(createFilterParam("auditor", auditedBy, "string", LIKE));
      }
      if (!isEmpty(selectedBranches)) {
        const filterParam = createFilterParam(
          "branchCode",
          selectedBranches.label,
          "string",
          LIKE
        );
        filters.push(filterParam);
      }
      result.filters = filters;
      result.isFilterChanged = isFilterChanged;
      if (orderBy?.length) {
        result.orderBy = orderBy;
      }
      if (!isEmpty(limit)) {
        result.limit = limit;
      }

      reportRef.current?.applyFilters(result);
    },
    [
      branch,
      endDate,
      orderBy,
      startDate,
      auditStartDate,
      auditEndDate,
      medicine,
      batch,
      auditId,
      auditedBy,
      limit,
      reportRef,
      selectedBranches,
    ]
  );
  const filterListener = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrl = event.ctrlKey;
    if (ctrl && key === "enter") {
      event.preventDefault();
      return applyFilterRef.current.click();
    }
  }, []);
  const filterContent = (
    <>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="sar_filter_start_date"
            label="Audit Request Start Date"
            inputRef={filterStartDateRef}
            onChange={(value) => setStartDate(value)}
            onFocus={() => setCurrentComponent("sar_filter_start_date")}
            value={startDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_start_date",
                down: "sar_filter_end_date",
                left: "sar_filter_start_date",
                right: "sar_filter_end_date",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="sar_filter_end_date"
            label="Audit Request End Date"
            inputRef={filterEndDateRef}
            onChange={(value) => setEndDate(value)}
            onFocus={() => {
              executeScroll(filterEndDateRef);
              setCurrentComponent("sar_filter_end_date");
            }}
            value={endDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_start_date",
                down: "sar_filter_start_date_audit",
                left: "sar_filter_start_date",
                right: "sar_filter_start_date_audit",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="sar_filter_start_date_audit"
            label="Audit Start Date"
            inputRef={filterAuditStartDateRef}
            onChange={(value) => setAuditStartDate(value)}
            onFocus={() => {
              executeScroll(filterAuditStartDateRef);
              setCurrentComponent("sar_filter_start_date_audit");
            }}
            value={auditStartDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_end_date",
                down: "sar_filter_end_date_audit",
                left: "sar_filter_end_date",
                right: "sar_filter_end_date_audit",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="sar_filter_end_date_audit"
            label="Stock Audit End Date"
            inputRef={filterAuditEndDateRef}
            onChange={(value) => setAuditEndDate(value)}
            onFocus={() => {
              executeScroll(filterAuditEndDateRef);
              setCurrentComponent("sar_filter_end_date_audit");
            }}
            value={auditEndDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_start_date_audit",
                down: "sar_filter_audit_request_id",
                left: "sar_filter_start_date_audit",
                right: "sar_filter_audit_request_id",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="sar_filter_audit_request_id"
            label="Store Stock Audit ID"
            ref={filterAuditRequestIdRef}
            value={auditId}
            onChange={(e) => setAuditId(e.target.value)}
            onFocus={() => {
              executeScroll(filterAuditRequestIdRef);
              setCurrentComponent("sar_filter_audit_request_id");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_end_date_audit",
                down: "sar_filter_branch_code",
                left: "sar_filter_end_date_audit",
                right: "sar_filter_branch_code",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="sar_filter_branch_code"
            value={selectedBranches}
            ref={filterBranchCodeRef}
            options={branchSuggestions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label;
            }}
            onChange={(e, value) => {
              setSelectedBranches(value);
            }}
            onFocus={() => {
              executeScroll(filterBranchCodeRef);
              setCurrentComponent("sar_filter_branch_code");
            }}
            disableClearable={false}
            onInputChange={handleBranchInputChange}
            label="Branch Code"
            disableCloseOnSelect={false}
            noOptionsText="Search branch code"
            markers={JSON.stringify({
              up: "sar_filter_audit_request_id",
              down: "sar_filter_branch_name",
              right: "sar_filter_branch_name",
              left: "sar_filter_audit_request_id",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="sar_filter_branch_name"
            label="Branch Name"
            ref={filterBranchRef}
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
            onFocus={() => {
              executeScroll(filterBranchRef);
              setCurrentComponent("sar_filter_branch_name");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_branch_code",
                down: "sar_filter_medicine_name",
                left: "sar_filter_branch_code",
                right: "sar_filter_medicine_name",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="sar_filter_medicine_name"
            label="Medicine Name"
            ref={filterMedicineRef}
            value={medicine}
            onChange={(e) => setMedicine(e.target.value)}
            onFocus={() => {
              executeScroll(filterMedicineRef);
              setCurrentComponent("sar_filter_medicine_name");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_branch_name",
                down: "sar_filter_batch_no",
                left: "sar_filter_branch_name",
                right: "sar_filter_batch_no",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="sar_filter_batch_no"
            label="Batch Number"
            ref={filterBatchRef}
            value={batch}
            onChange={(e) => setBatch(e.target.value)}
            onFocus={() => {
              executeScroll(filterBatchRef);
              setCurrentComponent("sar_filter_batch_no");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_medicine_name",
                down: "sar_filter_audited_by",
                left: "sar_filter_medicine_name",
                right: "sar_filter_audited_by",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="sar_filter_audited_by"
            label="Audited By"
            ref={filterAuditedByRef}
            value={auditedBy}
            onChange={(e) => setAuditedBy(e.target.value)}
            onFocus={() => {
              executeScroll(filterAuditedByRef);
              setCurrentComponent("sar_filter_audited_by");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_batch_no",
                down: "sar_filter_limit",
                left: "sar_filter_batch_no",
                right: "sar_filter_limit",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <NumberInput
            id="sar_filter_limit"
            label="Limit"
            ref={filterLimitRef}
            onValueChange={(values) => setLimit(values.floatValue)}
            isAllowed={(values) => values?.formattedValue <= 999999}
            onFocus={() => {
              executeScroll(filterLimitRef);
              setCurrentComponent("sar_filter_limit");
            }}
            value={limit}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_audited_by",
                down: "sar_apply_filter_button",
                left: "sar_filter_audited_by",
                right: "sar_apply_filter_button",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  const filterFooter = (
    <>
      <FilterGroup>
        <FilterItem>
          <Button
            id="sar_apply_filter_button"
            label="Apply"
            endIcon={<Shortcut keys={["Ctrl", "Enter"]} />}
            ref={applyFilterRef}
            onClick={() => applyFilterHandler(true)}
            markers={JSON.stringify({
              up: "sar_filter_limit",
              left: "sar_filter_limit",
              down: "sar_apply_filter_button",
              right: "sar_apply_filter_button",
            })}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  useEffect(() => {
    if (refreshData) {
      applyFilterHandler(true);
    }
  }, [refreshData, applyFilterHandler]);
  useEffect(() => {
    if (onFilterShow) {
      filterStartDateRef?.current.focus({ preventScroll: true });
    }
  }, [onFilterShow]);

  useEffect(() => {
    if (onFilterShow) document.addEventListener("keyup", filterListener, false);
    return () => {
      document.removeEventListener("keyup", filterListener, false);
    };
  }, [filterListener, onFilterShow]);

  useEffect(() => {
    if (applyFilterOnMount) applyFilterHandler();
  }, [applyFilterOnMount]);

  return <Filters filterContent={filterContent} filterFooter={filterFooter} />;
};

export default MedicineWiseStockAuditReportFilter;
